import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { UpdateSupplierOfficeInput } from "@/gql/graphql";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { SupplierOfficeForm } from "@/app/Offices/Forms/SupplierOfficeForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { updateSupplierOfficeMutation } from "@/app/Offices/GraphQL/supplierOfficeMutations";
import { supplierOfficeRecordQuery } from "@/app/Offices/GraphQL/supplierOfficeRecordQuery";
import { useTranslations } from "use-intl";

export function OfficeUpdateDialog({ officeId }: { officeId: string }) {
  const t = useTranslations("office");
  const { mutateAsync } = useGqlMutation(updateSupplierOfficeMutation);
  const { close } = useDialogState();

  const { data } = useSuspenseGqlQuery(supplierOfficeRecordQuery, {
    id: officeId,
  });

  const office = data.supplierOffice;

  return (
    <BaseDialog title={t("dialogs.update_office_title")}>
      <GenericForm<UpdateSupplierOfficeInput>
        onSubmit={async (values) => {
          await mutateAsync({
            id: office.id,
            input: values,
          });

          return close();
        }}
        initialValues={{
          supplier: {
            connect: office.supplier.id,
          },
          name: office.name,
          code: office.code,
          phone: office.phone,
          email: office.email,
          address: {
            upsert: {
              id: office.address.id,
              address_line_1: office.address.address_line_1,
              address_line_2: office.address.address_line_2,
              city: office.address.city,
              postcode: office.address.postcode,
              country: office.address.country,
              state: office.address.state,
            },
          },
          city: {
            connect: office.city.id,
          },
          pickup_instructions: office.pickup_instructions,
          delivery_hours: office.delivery_hours,
          departure_hours: office.departure_hours,
        }}
      >
        <SupplierOfficeForm
          initialLat={office.address?.lat}
          initialLng={office.address?.lng}
        />
        <DialogSubmitButton text={t("actions.update_office")} />
      </GenericForm>
    </BaseDialog>
  );
}
